import orderHistoryAddProductsCollectData from 'account/orderHistory/orderHistoryAddProducts/orderHistoryAddProductsCollectData';
import { Events } from 'global/constants';

class OrderHistoryAddProductsObservable {
	constructor() {
		const addProductsSection = document.querySelector(
			'[data-id="orderHistoryAddProducts"]',
		);
		this.pubSub = window.od.events;
		if (addProductsSection) {
			addProductsSection.addEventListener(
				'change',
				this.handleChange.bind(this),
			);
			this.pubSub.subscribe(
				Events.ADD_PRODUCTS_SELECTED_PRODUCTS_CHANGED,
				this.notifyObservers.bind(this),
			);
		}
	}

	handleChange({ target }) {
		if (target.hasAttribute('data-product-add-checkbox')) {
			this.notifyObservers();
		}
	}

	notifyObservers() {
		const products = document.querySelectorAll(
			'[data-product-row-add-product]',
		);
		const data = orderHistoryAddProductsCollectData(products);
		this.pubSub.publish(Events.ADD_PRODUCTS_SELECTED_PRODUCTS_UPDATE, data);
	}
}

export default OrderHistoryAddProductsObservable;
